import { SetFieldValue, ToggleSwitch } from '../../../gs-component-form';
import { Field as FormikField } from 'formik';
import React from 'react';

import DetailBox from '../DetailBox';
import RightRailSection from '../RightRailSection';

interface Props {
  setFieldValue: SetFieldValue;
  hasWWS: boolean;
  customEvent?: boolean;
  namePrefix?: string;
}

const SWITCH_LABEL_EVENT_VISIBLE = 'Show this event on my Website';
const SWITCH_LABEL_RSVP_REQUIRED = 'Allow guests to RSVP';

export const WeddingWebsiteForm: React.FC<Props> = ({
  customEvent = false,
  hasWWS,
  setFieldValue,
  namePrefix = '',
}: Props) => {
  if (!hasWWS) return null;
  return (
    <RightRailSection name="Wedding Website & RSVP Settings">
      {!customEvent && (
        <DetailBox>
          <div>{SWITCH_LABEL_EVENT_VISIBLE}</div>
          <FormikField
            name={`${namePrefix}visible`}
            // @ts-ignore
            component={props => <ToggleSwitch aria-label={SWITCH_LABEL_EVENT_VISIBLE} {...props} />}
            setFieldValue={setFieldValue}
          />
        </DetailBox>
      )}
      <DetailBox>
        <div>{SWITCH_LABEL_RSVP_REQUIRED}</div>
        <FormikField
          name={`${namePrefix}requireRsvp`}
          // @ts-ignore
          component={props => <ToggleSwitch aria-label={SWITCH_LABEL_RSVP_REQUIRED} {...props} />}
          setFieldValue={setFieldValue}
        />
      </DetailBox>
    </RightRailSection>
  );
};
